// extracted by mini-css-extract-plugin
export default {"headerBackground":"RSCatalogScreen_headerBackground__C+IaY"};